module.exports = __webpack_public_path__ + "9c0eda8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/adminBG.jpg
// module id = 2757
// module chunks = 15